import { Component, Input } from '@angular/core';
import { HiddenQuestionV3 } from '../../../classes/question-hidden';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-hidden-v3',
  templateUrl: './input-hidden.component.html',
  styleUrls: ['./input-hidden.component.scss'],
  standalone: false
})
export class InputHiddenComponentV3 extends QuestionBaseV3ComponentDirective {
  @Input() question: HiddenQuestionV3;
  @Input() color: string;
  @Input() type: string;
  @Input() name: string;
  @Input() id: string;
  @Input() value: any;
}
